export async function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export async function inlineImagesInLayoutHtml(html: string): Promise<string> {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const imgs = Array.from(doc.querySelectorAll<HTMLImageElement>('img[src^="http"]'));
  for (const img of imgs) {
    try {
      const response = await fetch(img.src, { mode: 'cors', credentials: 'omit' });
      const contentType = response.headers.get('Content-Type') ?? '';
      if (!contentType.startsWith('image/')) {
        throw new Error(`Non-image response (${contentType}) for ${img.src}`);
      }
      const blob = await response.blob();
      const dataUri = await blobToBase64(blob);
      img.src = dataUri;
    } catch (error) {
      console.warn(`Failed to inline image for PDF: ${img.src}`, error);
    }
  }
  return doc.body.innerHTML;
}
